import React from "react";
import styled from "styled-components";
import img_disputa from "../../imagens/apple-touch-icon.png";
import {ContainerHome} from "../styleMobile";

export const Wrapper = styled.div`
    height: 75vh;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: white;
    text-align: center;
    justify-items: center;
    justify-content: center;
    align-items: center;
    margin-top: -50px;
    
    h1{
       
       font-size: 40px;
       margin: 0;
   }
   
   p{
    margin-top: 20px;
    margin-bottom: 0;
    width: 80%;
    font-size: 25px;
   }
   
   div{
   background: green;
   border-radius: 10px;
   padding: 7px 10px 7px 10px;
   margin-top: 60px;
   a{
    color: white;
    text-decoration: none;
   }
   }
    
`;
export const Home = ({id}) => {
    return (
        <ContainerHome id={id} background={'#4B708A'}>
            <Wrapper>
                <img
                    src={img_disputa}
                    height={"auto"}
                    width={"150px"}
                    alt={"logo wavecode"}
                />
                <p>PLATAFORMA</p>
                <h1>WAVECODE</h1>
                <div><a href={'https://oferta.wavecode.com.br/plataforma-wavecode'}>TESTE GRÁTIS</a> </div>
            </Wrapper>
        </ContainerHome>
    )
};